/*
 * Copyright (c) 2016-2018 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

// @TODO Make this an enum
export const ALERT_TYPES: string[] = ['info', 'warning', 'danger', 'success'];
